export default "__VITE_ASSET__CJHGfrgY__"